import React, { useState } from 'react';

import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import { get } from 'lodash';

import MenuLumaBotActions from './MenuLumaBotActions';

export interface IconButtonLumaBotActionsProps extends Omit<IconButtonProps, 'classes' | 'onClick'> {}

const IconButtonLumaBotActions: React.FC<IconButtonLumaBotActionsProps> = ({ ...rest }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [menuListWidth, setMenuListWidth] = useState();

  return (
    <>
      <IconButton
        aria-label="More"
        aria-owns={anchorEl ? 'MenuLumaBotActions' : undefined}
        aria-haspopup="true"
        onClick={(event) => {
          setMenuListWidth(get(event, 'currentTarget.parentElement.offsetWidth'));
          setAnchorEl(event.currentTarget.parentElement);
        }}
        {...rest}
      />
      <MenuLumaBotActions
        id="MenuLumaBotActions"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        MenuListProps={{
          disablePadding: true,
          style: {
            width: menuListWidth,
          },
        }}
      />
    </>
  );
};

export default IconButtonLumaBotActions;
